import { GrantDiscordAccessMutation1e5ff0b653k4l as GrantDiscordAccessMutation } from './schema/GrantDiscordAccessMutation.mjs';
import { toVoidResult8ga34bq1f52r as toVoidResult } from './SdkGrantSlackAccess.mjs';
import { Unauthorized_instance3p96f1r9ta19w as Unauthorized_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatcher27uwezb7p8fpg as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantDiscordAccessCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { GrantDiscordAccessInputqu7hxtlblgwv as GrantDiscordAccessInput } from './schema/type/GrantDiscordAccessInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  var tmp0_safe_receiver = (yield* this.i6s(new (GrantDiscordAccessMutation())(grantDiscordAccessInput(command)), $completion)).q44_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z6g_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toVoidResult(tmp1_safe_receiver);
  return tmp2_elvis_lhs == null ? Unauthorized_instance : tmp2_elvis_lhs;
}
var SdkGrantDiscordAccessClass;
function SdkGrantDiscordAccess() {
  if (SdkGrantDiscordAccessClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkGrantDiscordAccess', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkGrantDiscordAccessClass = $;
  }
  return SdkGrantDiscordAccessClass;
}
function grantDiscordAccessInput(_this__u8e3s4) {
  return new (GrantDiscordAccessInput())(_this__u8e3s4.b2j_1, _this__u8e3s4.d2j_1, _this__u8e3s4.c2j_1);
}
//region block: exports
export {
  SdkGrantDiscordAccess as SdkGrantDiscordAccessjjorbkvtrfx9,
  perform as perform3pwdogs48g0kz,
};
//endregion

//# sourceMappingURL=SdkGrantDiscordAccess.mjs.map
